import React from "react";
import { VerticalLineMobile, VerticalLineMobileLong } from "../../Epics/Grants/Pages/HowItWorks/styles";
import AccordionMobile from "../TimeLineAccordion/AccordionMobile";
import TimeLineStatus from "../TimeLineAccordion/TimeLineStatus";

export default ({ desktopRefs, howItWorksDetails, handleScrollToTOp }) => {
  return (
    <div data-test="GrantStepMobile">
      <AccordionMobile
        stepCount={1}
        howItWorksDetails={howItWorksDetails}
        myCustomRef={desktopRefs[0]}
        handleScrollToTOp={handleScrollToTOp}
      />
    <VerticalLineMobile />
      <AccordionMobile
        stepCount={2}
        howItWorksDetails={howItWorksDetails}
        myCustomRef={desktopRefs[1]}
        handleScrollToTOp={handleScrollToTOp}
      />

<VerticalLineMobileLong />

      <TimeLineStatus
        statusTitle={howItWorksDetails.field_step_2_status_title}
        statusOne={howItWorksDetails.field_step_2_status_1}
        statusOneTooltip={howItWorksDetails.field_step_2_status_1_tooltip}
        statusTwo={howItWorksDetails.field_step_2_status_2}
        statusTwoTooltip={howItWorksDetails.field_step_2_status_2_tooltip}
        isMobile={true}
        type={2}
      />
    <VerticalLineMobile />

      <AccordionMobile
        stepCount={3}
        howItWorksDetails={howItWorksDetails}
        myCustomRef={desktopRefs[2]}
        handleScrollToTOp={handleScrollToTOp}
      />

<VerticalLineMobileLong />

      <TimeLineStatus
        statusTitle={howItWorksDetails.field_step_3_status_title}
        statusOne={howItWorksDetails.field_step_3_status_1}
        statusOneTooltip={howItWorksDetails.field_step_3_status_1_tooltip}
        statusTwo={howItWorksDetails.field_step_3_status_2}
        statusTwoTooltip={howItWorksDetails.field_step_3_status_2_tooltip}
        isMobile={true}
        type={3}
      />

<VerticalLineMobile />

      <AccordionMobile
        stepCount={4}
        howItWorksDetails={howItWorksDetails}
        myCustomRef={desktopRefs[3]}
        handleScrollToTOp={handleScrollToTOp}
      />

<VerticalLineMobileLong />

      <TimeLineStatus
        statusTitle={howItWorksDetails.field_step_4_status_title}
        statusOne={howItWorksDetails.field_step_4_status_1}
        statusOneTooltip={howItWorksDetails.field_step_4_status_1_tooltip}
        statusTwo={howItWorksDetails.field_step_4_status_2}
        statusTwoTooltip={howItWorksDetails.field_step_4_status_2_tooltip}
        isMobile={true}
        type={4}
      />
    </div>
  );
};
